import React from 'react';
import PropTypes from 'prop-types';
import { st, classes } from './SkeletonRectangle.st.css.js';
import { DEFAULT_HEIGHT, DEFAULT_WIDTH } from './constants';
import { DEFAULT_SKIN, SKIN_COLOR, } from '../SkeletonGroup/SkeletonGroup.constants';
import Box from '../Box';
import { SkeletonGroupContext } from '../SkeletonGroup';
function SkeletonRectangle(props) {
    const { dataHook, className, height = DEFAULT_HEIGHT, width = DEFAULT_WIDTH, margin, marginLeft, marginRight, marginTop, marginBottom, } = props;
    return (React.createElement(SkeletonGroupContext.Consumer, null, context => {
        const skin = (context && context.skin) || DEFAULT_SKIN;
        return (React.createElement("div", { "data-hook": dataHook, className: className, "data-height": height, "data-width": width, "data-skin": skin },
            React.createElement(Box, { height: height, width: width, margin: margin, marginLeft: marginLeft, marginRight: marginRight, marginTop: marginTop, marginBottom: marginBottom, backgroundColor: SKIN_COLOR[skin], className: st(classes.root, { skin }) })));
    }));
}
SkeletonRectangle.displayName = 'SkeletonRectangle';
SkeletonRectangle.propTypes = {
    dataHook: PropTypes.string,
    className: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    margin: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    marginTop: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    marginRight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    marginBottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    marginLeft: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
export default SkeletonRectangle;
//# sourceMappingURL=SkeletonRectangle.js.map